import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8961eb30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "herder-container" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 搜索 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 已创建的选品单 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 新建选品单 ")
const _hoisted_8 = { class: "user" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 退出登录 ")

import { CaretBottom } from '@element-plus/icons-vue'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { ref } from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    cartCount: null,
    disabled: { type: Boolean },
    pageName: null,
    inputPlaceholder: null
  },
  emits: ["search", "navCart"],
  setup(__props: any, { emit }: { emit: ({(e: 'search', searchVal: string): void, (e: 'navCart', id: number): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  cartCount: number
  disabled: boolean
  pageName:string
  inputPlaceholder:string
}

const store = useStore()
const route = useRoute()
const router = useRouter()
const searchInput = ref('')
const admin = ref(store.state.user.name)

const loginOut = () => {
  store.dispatch(UserActionTypes.ACTION_LOGIN_OUT, undefined)
  router.push(`/login?redirect=${route.fullPath}`).catch((err) => {
    console.warn(err)
  })
}
const goHome = () => {
  if (props.pageName) {
    search()
  } else {
    router.push('/products')
  }
}


const search = () => {
  emit('search', searchInput.value)
}
const reset = () => {
  searchInput.value = ''
  search()
}
const navSelectionHistory = () => {
  router.push('/selectionHistory')
}
const navProducts = () => {
  router.push('/products')
}
// const navCart = () => {
//   emit('navCart', -1)
// }

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_image, {
      class: "logo-img",
      src: require('Assets/images/header/ic_font_logo.png'),
      onClick: goHome
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        disabled: __props.disabled,
        class: "input",
        placeholder: __props.inputPlaceholder|| '请输入商品名',
        modelValue: searchInput.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
        onKeyup: _withKeys(search, ["enter"])
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_el_image, {
            class: "input-ic",
            src: require('Assets/images/header/ic_search.png')
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["disabled", "placeholder", "modelValue", "onKeyup"])
    ]),
    _createVNode(_component_el_button, {
      class: "search-btn",
      type: "primary",
      onClick: search
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      class: "reset",
      type: "info",
      onClick: reset
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _hoisted_5,
    (__props.pageName === 'products')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "selection-history",
          onClick: navSelectionHistory
        }, [
          _createVNode(_component_el_image, {
            class: "ic",
            src: require('Assets/images/header/ic_selection_history.png')
          }, null, 8, ["src"]),
          _hoisted_6
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "selection-history",
          onClick: navProducts
        }, [
          _createVNode(_component_el_image, {
            class: "ic",
            src: require('Assets/images/header/ic_add_selection.png')
          }, null, 8, ["src"]),
          _hoisted_7
        ])),
    _createVNode(_component_el_dropdown, { class: "header-dropdown" }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { onClick: loginOut }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_avatar, {
            size: 26,
            src: require('Assets/images/ic_default_avatar.png')
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_9, "管理员" + _toDisplayString(admin.value), 1),
          _createVNode(_component_el_icon, { color: "#000" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CaretBottom))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})